<template>
    <div>
        <h2 class="text-base font-medium text-gray-700 mb-1 text-center">Status</h2>
        <div class="bg-gray-50 border border-gray-200 rounded-xl p-4 text-sm">
            <div v-html="getStatus()"></div>
            <div v-if="!user.connected" class="text-red-600 text-xs mt-2">Remote connection lost, attempting to
                re-connect...
            </div>
            <div class="w-full mt-3 pt-3 border-t border-gray-200">
                <div class="flex w-full pt-1">
                    <div class="text-sm flex-1">Status</div>
                    <div class="text-right pl-4 text-sm font-open-sans tabular-nums font-semibold"
                         :class="rams.status==='Rejected by Client'?'text-red-800':(rams.status==='Approved by Client'?'text-green-600':'')">
                        {{ rams.status }}
                    </div>
                </div>
                <template v-if="rams.status === 'Approved by Client' || rams.status === 'Rejected by Client'">
                    <div class="flex w-full pt-1">
                        <div class="text-sm flex-1">At:</div>
                        <div class="text-right pl-4 text-sm font-open-sans tabular-nums font-semibold"
                             v-text="rams.response.dateTime">
                        </div>
                    </div>
                    <div class="flex w-full pt-1">
                        <div class="text-sm flex-1">Name:</div>
                        <div class="text-right pl-4 text-sm font-open-sans tabular-nums font-semibold"
                             v-text="rams.response.name">
                        </div>
                    </div>
                    <template v-if="rams.status === 'Approved by Client'">
                        <div class="flex w-full pt-1">
                            <div class="text-sm flex-1">Signature:</div>
                            <div class="text-right pl-4 text-sm font-open-sans tabular-nums font-semibold">
                                <img :src="rams.response.signature" style="max-width:150px; max-height: 75px;"
                                     alt="signature">
                            </div>
                        </div>
                    </template>
                    <template v-else-if="rams.status === 'Rejected by Client'">
                        <div class="text-sm pt-1">Rejection Comments:</div>
                        <div
                            class="py-1 px-2 mt-1 text-xs text-gray-600 bg-white border border-gray-200 rounded-xl min-h-3 whitespace-pre-wrap"
                            v-text="rams.response.comment">
                        </div>
                    </template>
                </template>
            </div>

        </div>
    </div>
</template>

<script>

import {RAMS} from "../../../models";
import moment from "moment";
import User from "../../../services/User";
import UiToggle from "../../ui/UiToggle.vue";

export default {
    components: {UiToggle},
    props: {
        rams: RAMS,
    },
    data() {
        return {
            lastSaving: false,
            lastSaved: false,
            interval: 0,
            user: Object,
            editToggle: !this.rams.readonly,
        }
    },
    methods: {
        getStatus() {
            if (this.rams.locked) {
                return 'RAMS is Locked'
            } else if (this.rams.saving) {
                this.interval = setTimeout(() => {
                    this.$forceUpdate();
                }, 400);
                if (moment().diff(this.lastSaving, 'seconds') > 3) {
                    return 'Saving...<br/><br/>Connection interrupt detected......   Continuing to attempt to save..'
                }
                return 'Saving...'
            } else if (this.rams.error) {
                return '<span class="text-red-600">WARNING - Server error on save detected!</span><br/><br/>You may still make changes, but they will probably NOT survive a page reload or a switch from edit mode.<br/><br/>Please stop what you are doing and contact support to report this.<br/><br>Server message: <span class="text-red-600">' + ((this.rams.error.data && this.rams.error.data.message) ? this.rams.error.data.message : JSON.stringify(this.rams.error.data)) + '</span>'
            } else if (User.user.loggedOut) {
                User.register()
                if (User.user.loggedOut) {
                    this.interval = setTimeout(() => {
                        this.$forceUpdate();
                    }, 3000);
                    return '<span class="text-red-600">WARNING - You are not logged in!</span><br/><br/>You may still make changes, but they will NOT survive a page reload unless you log in.<br/><br/>Log in using a different browser tab to keep any changes.';
                }
            }
            return this.lastSaved ? 'Saved ' + this.lastSaved.fromNow() : 'No changes yet made';
        },
        getConnectionStatus() {
            return ''
        }
    },
    mounted() {
        this.user = User;
        eventBus.$on('rams-saving', (rams) => {
            if (rams === this.rams) {
                this.lastSaving = moment()
                this.$forceUpdate();
            }
        });
        eventBus.$on('rams-saved', (rams) => {
            if (rams === this.rams) {
                this.lastSaved = moment()
            }
        });
    },
}
</script>
